import { render } from "./SkeletonTable.vue?vue&type=template&id=ac25de4a&scoped=true"
import script from "./SkeletonTable.vue?vue&type=script&lang=js"
export * from "./SkeletonTable.vue?vue&type=script&lang=js"

import "./SkeletonTable.vue?vue&type=style&index=0&id=ac25de4a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac25de4a"]])

export default __exports__